import { utils, writeFile } from 'xlsx';

import { columnName, normalizeRow } from './aiDataUtils';

const SHEET_NAME = 'Data';
const MAX_FILE_NAME = 100;

export function safeFileName(name) {
  const cleaned = (name || 'chart')
    .replace(/[\\/:*?"<>|]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  return (cleaned || 'chart').slice(0, MAX_FILE_NAME);
}

export function toExportRows(columns, rows) {
  const safeRows = Array.isArray(rows) ? rows : [];
  const hasColumns = Boolean(columns && columns.length);
  const headers = (hasColumns ? columns : Object.keys(safeRows[0] || {})).map((column, index) =>
    columnName(column, index)
  );
  const normalizedRows = hasColumns ? safeRows.map(row => normalizeRow(row, columns)) : safeRows;
  return { headers, rows: normalizedRows };
}

export function exportRowsToExcel(columns, rows, fileBaseName) {
  const { headers, rows: exportRows } = toExportRows(columns, rows);

  const worksheet = utils.json_to_sheet(exportRows, { header: headers });
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, SHEET_NAME);
  writeFile(workbook, `${safeFileName(fileBaseName)}.xlsx`);
}
